module.exports = __webpack_public_path__ + "static/media/template.5c1d4562.svg";